<template>
  <div>
    
    <div class="container2">
        <div class="title">
            <p>法律法规</p>
            <!-- <span @click="hangleLaw">更多资料
                <i class="el-icon-arrow-right"></i>
            </span> -->
            <el-button type="primary" round @click="hangleLaw">
                更多资料<i class="el-icon-arrow-right"></i>
            </el-button>
        </div>
        <div class="boxs">
            <div class="boxs-title">
              <p >环境保护</p>
              <span class="cont3-right" @click="hangleLaw">更多+</span>
            </div>
            <div class="cont3">
                <div  v-for="item in Environmental" :key="item.id" @click="HandleDetailId(item)">
                    <p class="context-cont3">{{ item.title }}</p>
                    <div class="dividerD"></div>
                </div>
            </div>
        </div>
        <div class="boxs">
            <div class="boxs-title">
              <p >消防咨询</p>
              <span class="cont3-right" @click="hangleLaw">更多+</span>
            </div>
            <div class="cont3">
                <div  v-for="item in fireConsultation" :key="item.id" @click="HandleDetailId(item)">
                    <p class="context-cont3">{{ item.title }}</p>
                    <div class="dividerD"></div>
                </div>
            </div>
        </div>
        <div class="boxs">
            <div class="boxs-title">
              <p >职业健康</p>
              <span class="cont3-right" @click="hangleLaw">更多+</span>
            </div>
            <div class="cont3">
                <div  v-for="item in occupationalHealth" :key="item.id" @click="HandleDetailId(item)">
                    <p class="context-cont3">{{ item.title }}</p>
                    <div class="dividerD"></div>
                </div>
            </div>
        </div>
        <div class="boxs">
            <div class="boxs-title">
              <p >特种设备</p>
              <span class="cont3-right" @click="hangleLaw">更多+</span>
            </div>
            <div class="cont3">
                <div  v-for="item in specialEquipment" :key="item.id" @click="HandleDetailId(item)">
                    <p class="context-cont3">{{ item.title }}</p>
                    <div class="dividerD"></div>
                </div>
            </div>
        </div>
        <div class="boxs">
            <div class="boxs-title">
              <p >安全生产</p>
              <span class="cont3-right" @click="hangleLaw">更多+</span>
            </div>
            <div class="cont3">
                <div  v-for="item in safeproduction" :key="item.id" @click="HandleDetailId(item)">
                    <p class="context-cont3">{{ item.title }}</p>
                    <div class="dividerD"></div>
                </div>
            </div>
        </div>
        <div class="boxs">
            <div class="boxs-title">
              <p >防雷检测</p>
              <span class="cont3-right" @click="hangleLaw">更多+</span>
            </div>
            <div class="cont3">
                <div  v-for="item in lightningProtection" :key="item.id" @click="HandleDetailId(item)">
                    <p class="context-cont3">{{ item.title }}</p>
                    <div class="dividerD"></div>
                </div>
               
            </div>
        </div>
    </div>
    
  </div>
</template>
<script>
export default{
    data(){
        return{
            Environmental: [],
            fireConsultation: [],
            occupationalHealth: [],
            specialEquipment: [],
            safeproduction: [],
            lightningProtection: [],
        }
    },
    methods: {
        getListarticle(data){
            this.$store.dispatch('menu/getMenu',data)
                .then(res => {
                    if(res.ok){
                        if(data.maintype_ids == 122){
                            this.Environmental = res.data.items
                        }else if(data.maintype_ids == 123){
                            this.fireConsultation = res.data.items
                        }else if(data.maintype_ids == 124){
                            this.occupationalHealth = res.data.items
                        }else if(data.maintype_ids == 125){
                            this.specialEquipment = res.data.items
                        }else if(data.maintype_ids == 126){
                            this.safeproduction = res.data.items
                        }else if(data.maintype_ids == 127){
                            this.lightningProtection = res.data.items
                        }
                    }
                })
        },
        hangleLaw(){
            this.$router.push({
                path: '/article',
            })
            // const { href } = this.$router.resolve({
            //     name: "/article",
            // });
            // window.open(href, '_blank');

            sessionStorage.setItem("name",'法律法规') 
            sessionStorage.setItem("channel",'law')
        },
        HandleDetailId(item){
            // this.$router.push({
            //     path: '/detailPages',
            //     query:{
            //         key: item.id,
            //         currentName: '法律法规'
            //     }
            // })

            const { href } = this.$router.resolve({
                path: "/detailPages",
                query: {
                    key: item.id,
                    currentName: '法律法规'
                }
            });
            window.open(href, '_blank');
        },
        
    },
    mounted(){
        // 环保服务
       this.getListarticle({
        channel: 'law',
        pageNum: 1,
        pageSize: 5,
        maintype_ids: 122,
        keywords: '',
       } )

        // 消防咨询
       this.getListarticle( {
            channel: 'law',
            pageNum: 1,
            pageSize: 5,
            maintype_ids: 123,
            keywords: '',
        })

         // 职业健康
        this.getListarticle( {
            channel: 'law',
            pageNum: 1,
            pageSize: 5,
            maintype_ids: 124,
            keywords: '',
        })
         // 特种设备
        this.getListarticle( {
            channel: 'law',
            pageNum: 1,
            pageSize: 5,
            maintype_ids: 125,
            keywords: '',
        })
          // 安全生产
         this.getListarticle( {
            channel: 'law',
            pageNum: 1,
            pageSize: 5,
            maintype_ids: 126,
            keywords: '',
        })
          // 防雷检测
        this.getListarticle( {
            channel: 'law',
            pageNum: 1,
            pageSize: 5,
            maintype_ids: 127,
            keywords: '',
        })
    }
}
</script>
<style scoped>

.container2{
    display: flex;
    justify-content: space-between;
    flex-flow: row wrap;
    align-items: center;
    margin-top: 20px;
    background: #fff;
    padding: 10px 10px;
    
}
.container2 .title{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 22px;
    font-weight: 700;
    /* background: rgb(187, 208, 247); */
    border-radius: 5px;
    border-bottom: 0.5px solid #f2f2f2;
    /* background: rgb(209, 223, 250,0.4); */
}
.container2 .title p{
    font-size: 22px;
    /* background: rgb(187, 208, 247);    */
    padding: 15px 15px;
    border-radius: 15px;
    margin-right: 60px;
}
.container2 .title span{
    cursor: pointer;
    font-size: 16px;
}
.container2 .title span:hover{
    color: #00a8a8;
}
.container2 .boxs{
    width: 32%;
    margin-bottom: 10px;
    margin-top: 10px;
}
.container2 .boxs .boxs-title{
   display: flex;
   justify-content: space-between;
   align-content: center;
}
.container2 .boxs .boxs-title p{
  padding: 10px 5px 0px 5px;
  margin-left: 10px;
  /* border-bottom: 0.5px solid #f2f2f2; */
  color: #008a8a;
  font-size: 20px;
}
.container2 .boxs .boxs-title span{
    font-size: 16px;
    color: #5087EC;
    line-height: 50px;
}
.cont3{
    width: 95%;
    margin: 5px auto;
    padding: 10px 10px;
    /* background: rgb(209, 223, 250,0.4); */
}
.cont3 .context-cont3{
    padding: 0;margin: 0;
    font-size: 16px;
    padding: 8px 0 5px 5px;
    /* height: 40px; */
    /* border-bottom: 1px solid #cfd9e2; */
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
}
.cont3 .context-cont3:hover{
    font-weight: 600;
}
.advertisement{
    display: flex;
    justify-content: space-between;
    height: 120px;
    margin-top: 20px;
    background: #fff;
    padding: 10px 10px;
}
.advertisement div{
    width: 48%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.advertisement div:nth-child(1){  
    background-image:url('../../assets/f1531cde-2b1c-49ee-87f4-0a21f37353c9.jpg');
}
.advertisement div:nth-child(2){  
    background-image:url('../../assets/cd3d4138-171a-47bf-8c67-4486256dfc37.jpg');
}
.dividerD{
    width: 100%;
    border-bottom: 0.5px solid #f2f2f2;
    margin: 10px 0;
}
.cont3-right{
    cursor: pointer;
}
.cont3-right:hover{
    
    color: #00a8a8;
}

@media screen and (max-width: 540px) {
    .container2{
        padding: 5px 5px 15px 0px;
        
    }
    .container2 .boxs{
        width: 100%;
        margin-bottom: 10px;
        margin-top: 10px;
    }
    .container2 .boxs .boxs-title{
        display: flex;
        justify-content: space-between;
        align-content: center;
        padding:  0 0;
    }
    .container2 .title p{
        font-size: 18px;
        padding: 15px 5px 15px 5px;
    }
    .container2 .boxs .boxs-title p{
        padding: 10px 7px 0px 7px;
        margin-left: 0px;
        font-size: 16px;
    }
    .container2 .boxs .boxs-title span{
        font-size: 16px;
        color: #5087EC;
        line-height: 50px;
    }

    .cont3 .context-cont3{
        font-size: 14px;
        padding: 8px 0 5px 0px;
    }
}
</style>